import React from "react";
import { Badge } from "./KgNodeIconBadge.styles";
import type { KgNodeIconBadgeProps } from "./KgNodeIconBadge.types";

export const KgNodeIconBadge: React.FC<KgNodeIconBadgeProps> = ({
  icon,
  color,
  bgColor,
  visualState = "default",
  className,
}) => (
  <Badge $color={color} $bgColor={bgColor} $visualState={visualState} className={className}>
    {icon}
  </Badge>
);

export default KgNodeIconBadge;
